global.toggleComponentInit = function () {
  $('.js-toggle-trigger').click((event) => {
    const target = $(event.currentTarget).data('target');
    $(`.js-collapsible:not(.js-toggle${target})`).addClass('hidden');
    $(`.js-toggle${target}`).toggleClass('hidden').trigger('toggle');
  });
};

$(document).on('turbolinks:load', toggleComponentInit);
